import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PortraitsPage() {
  const [selectedStyle, setSelectedStyle] = useState('tous');

  const styles = [
    { id: 'tous', name: 'Tous les styles' },
    { id: 'pixar', name: 'Style Pixar' },
    { id: 'aquarelle', name: 'Aquarelle' },
    { id: 'cartoon', name: 'Cartoon' },
    { id: 'realiste', name: 'Réaliste' },
  ];

  const portraits = [
    {
      id: 1,
      name: 'Portrait Famille Pixar',
      description: 'Transformez votre famille en personnages de film d\'animation',
      price: '49.90',
      style: 'pixar',
      image: 'https://public.readdy.ai/ai/img_res/ab02fd0cb3f25e260ebc6fc0cf69a77b.jpg',
      features: ['Jusqu\'à 6 personnes', 'Animaux inclus', 'Haute résolution', 'Révisions illimitées'],
    },
    {
      id: 2,
      name: 'Portrait Couple Romantique',
      description: 'Un portrait artistique de votre couple pour immortaliser votre amour',
      price: '39.90',
      style: 'aquarelle',
      image: 'https://readdy.ai/api/search-image?query=A%20romantic%20watercolor%20style%20couple%20portrait%20showing%20two%20people%20in%20love%20embracing%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20artistic%20brush%20strokes%2C%20simple%20clean%20background%20with%20gentle%20color%20washes%2C%20tender%20and%20emotional%20scene&width=500&height=600&seq=coupleaqua1&orientation=portrait',
      features: ['Style aquarelle', 'Fond personnalisé', 'Format A3', 'Livraison numérique'],
    },
    {
      id: 3,
      name: 'Portrait Enfant Cartoon',
      description: 'Votre enfant transformé en adorable personnage de dessin animé',
      price: '34.90',
      style: 'cartoon',
      image: 'https://readdy.ai/api/search-image?query=A%20cute%20cartoon%20style%20child%20portrait%20with%20big%20expressive%20eyes%2C%20playful%20smile%2C%20colorful%20outfit%2C%20simple%20clean%20background%20with%20soft%20colors%2C%20fun%20and%20cheerful%20atmosphere%2C%20professional%20illustration%20quality&width=500&height=600&seq=kidcartoon1&orientation=portrait',
      features: ['Style cartoon unique', 'Expressions personnalisées', 'Couleurs vives', 'Parfait pour chambre'],
    },
    {
      id: 4,
      name: 'Portrait avec Animal de Compagnie',
      description: 'Vous et votre compagnon à quatre pattes réunis dans un portrait magique',
      price: '44.90',
      style: 'pixar',
      image: 'https://readdy.ai/api/search-image?query=A%20Pixar%20Disney%20style%20portrait%20of%20a%20person%20hugging%20their%20beloved%20pet%20dog%2C%20warm%20loving%20scene%2C%20vibrant%20colors%2C%20simple%20soft%20background%20with%20pastel%20tones%2C%20emotional%20connection%2C%20professional%203D%20rendering%20quality&width=500&height=600&seq=petportrait1&orientation=portrait',
      features: ['Tous types d\'animaux', 'Poses personnalisées', 'Détails réalistes', 'Fond au choix'],
    },
    {
      id: 5,
      name: 'Portrait Grands-Parents',
      description: 'Un cadeau émouvant pour honorer vos grands-parents',
      price: '39.90',
      style: 'realiste',
      image: 'https://readdy.ai/api/search-image?query=A%20realistic%20artistic%20portrait%20of%20elderly%20grandparents%20smiling%20warmly%2C%20soft%20lighting%2C%20gentle%20colors%2C%20simple%20elegant%20background%20with%20warm%20tones%2C%20dignified%20and%20loving%20atmosphere%2C%20professional%20quality%20illustration&width=500&height=600&seq=grandparents1&orientation=portrait',
      features: ['Style réaliste', 'Retouches incluses', 'Impression possible', 'Cadre disponible'],
    },
    {
      id: 6,
      name: 'Portrait Fratrie',
      description: 'Immortalisez la complicité entre frères et sœurs',
      price: '44.90',
      style: 'cartoon',
      image: 'https://readdy.ai/api/search-image?query=A%20cartoon%20style%20portrait%20of%20siblings%20playing%20together%2C%20happy%20expressions%2C%20colorful%20clothing%2C%20simple%20clean%20background%20with%20cheerful%20colors%2C%20fun%20and%20energetic%20atmosphere%2C%20professional%20illustration%20quality&width=500&height=600&seq=siblings1&orientation=portrait',
      features: ['Jusqu\'à 4 enfants', 'Poses dynamiques', 'Couleurs personnalisées', 'Format au choix'],
    },
    {
      id: 7,
      name: 'Portrait Bébé Aquarelle',
      description: 'Un portrait doux et poétique de votre nouveau-né',
      price: '34.90',
      style: 'aquarelle',
      image: 'https://readdy.ai/api/search-image?query=A%20delicate%20watercolor%20style%20baby%20portrait%20with%20soft%20pastel%20colors%2C%20gentle%20brush%20strokes%2C%20dreamy%20atmosphere%2C%20simple%20clean%20background%20with%20light%20color%20washes%2C%20tender%20and%20peaceful%20scene&width=500&height=600&seq=babyaqua1&orientation=portrait',
      features: ['Style aquarelle doux', 'Couleurs pastel', 'Parfait pour naissance', 'Cadeau idéal'],
    },
    {
      id: 8,
      name: 'Portrait Famille Élargie',
      description: 'Réunissez toute la famille dans un portrait unique',
      price: '69.90',
      style: 'pixar',
      image: 'https://readdy.ai/api/search-image?query=A%20large%20Pixar%20Disney%20style%20extended%20family%20portrait%20with%20multiple%20generations%2C%20grandparents%20parents%20and%20children%2C%20warm%20happy%20atmosphere%2C%20colorful%20outfits%2C%20simple%20soft%20background%20with%20pastel%20colors%2C%20professional%203D%20rendering&width=500&height=600&seq=extendedfam1&orientation=portrait',
      features: ['Jusqu\'à 12 personnes', 'Plusieurs générations', 'Composition sur mesure', 'Qualité premium'],
    },
    {
      id: 9,
      name: 'Portrait Avatar Personnel',
      description: 'Créez votre avatar unique pour les réseaux sociaux',
      price: '24.90',
      style: 'cartoon',
      image: 'https://readdy.ai/api/search-image?query=A%20modern%20cartoon%20style%20personal%20avatar%20portrait%20with%20unique%20style%2C%20trendy%20outfit%2C%20expressive%20face%2C%20simple%20gradient%20background%20with%20vibrant%20colors%2C%20professional%20quality%20for%20social%20media%20use&width=500&height=600&seq=avatar2&orientation=portrait',
      features: ['Style moderne', 'Format carré', 'Optimisé réseaux sociaux', 'Livraison rapide'],
    },
  ];

  const filteredPortraits = selectedStyle === 'tous' 
    ? portraits 
    : portraits.filter(p => p.style === selectedStyle);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50"></div>
        <div className="relative max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-soft mb-6">
              <i className="ri-palette-line text-primary-coral"></i>
              <span className="font-quicksand font-semibold text-gray-700">Portraits Artistiques</span>
            </div>
            <h1 className="text-6xl font-fredoka font-bold text-gray-900 mb-6">
              Portraits{' '}
              <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 bg-clip-text text-transparent">
                Personnalisés
              </span>
            </h1>
            <p className="text-xl font-quicksand text-gray-600 max-w-3xl mx-auto mb-8">
              Transformez vos photos en œuvres d'art uniques. Choisissez parmi nos styles artistiques pour créer des portraits qui racontent votre histoire.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/contact"
                className="px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-quicksand font-bold rounded-full hover:shadow-colored-blue transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-brush-line"></i>
                <span>Commander mon portrait</span>
              </Link>
              <Link
                to="/fonctionnement"
                className="px-8 py-4 bg-white text-gray-900 font-quicksand font-semibold rounded-full shadow-soft hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Comment ça marche ?
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Style Filters */}
      <section className="py-8 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {styles.map((style) => (
              <button
                key={style.id}
                onClick={() => setSelectedStyle(style.id)}
                className={`px-6 py-3 rounded-full font-quicksand font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedStyle === style.id
                    ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-colored-blue'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {style.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Portraits Grid */}
      <section className="py-20 bg-neutral-lighter">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPortraits.map((portrait, index) => (
              <motion.div
                key={portrait.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Link
                  to={`/produit/${portrait.id}`}
                  className="group block bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                >
                  {/* Image */}
                  <div className="relative w-full h-96 overflow-hidden">
                    <img
                      src={portrait.image}
                      alt={portrait.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full">
                      <span className="font-quicksand font-semibold text-sm text-gray-900 capitalize">
                        {styles.find(s => s.id === portrait.style)?.name}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-2">
                      {portrait.name}
                    </h3>
                    <p className="font-quicksand text-gray-600 text-sm mb-4">
                      {portrait.description}
                    </p>

                    {/* Features */}
                    <div className="space-y-2 mb-4">
                      {portrait.features.slice(0, 3).map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <i className="ri-check-line text-primary-mint text-sm"></i>
                          <span className="font-quicksand text-sm text-gray-600">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <div className="text-xs font-quicksand text-gray-500 mb-1">
                          À partir de
                        </div>
                        <div className="text-3xl font-fredoka font-bold text-gray-900">
                          {portrait.price}€
                        </div>
                      </div>
                    </div>

                    <button className="w-full px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full group-hover:bg-gradient-to-r group-hover:from-purple-600 group-hover:to-pink-600 transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2">
                      <i className="ri-brush-line"></i>
                      <span>Créer mon portrait</span>
                    </button>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Comment créer votre portrait ?
            </h2>
            <p className="text-lg font-quicksand text-gray-600 max-w-2xl mx-auto">
              Un processus simple en 4 étapes pour obtenir votre portrait personnalisé
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                step: '1',
                icon: 'ri-image-line',
                title: 'Envoyez vos photos',
                description: 'Téléchargez vos meilleures photos en haute qualité',
                color: 'from-purple-500 to-purple-600',
              },
              {
                step: '2',
                icon: 'ri-palette-line',
                title: 'Choisissez le style',
                description: 'Sélectionnez le style artistique qui vous plaît',
                color: 'from-pink-500 to-pink-600',
              },
              {
                step: '3',
                icon: 'ri-brush-line',
                title: 'Nous créons',
                description: 'Nos artistes créent votre portrait personnalisé',
                color: 'from-orange-500 to-orange-600',
              },
              {
                step: '4',
                icon: 'ri-download-line',
                title: 'Recevez votre portrait',
                description: 'Téléchargez votre portrait en haute résolution',
                color: 'from-teal-500 to-teal-600',
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center"
              >
                <div className={`w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br ${item.color} rounded-2xl shadow-soft`}>
                  <i className={`${item.icon} text-4xl text-white`}></i>
                </div>
                <div className="mb-4">
                  <span className="inline-block w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full font-fredoka font-bold text-gray-900">
                    {item.step}
                  </span>
                </div>
                <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                  {item.title}
                </h3>
                <p className="font-quicksand text-gray-600">
                  {item.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl font-fredoka font-bold text-white mb-6">
              Prêt à créer votre portrait unique ?
            </h2>
            <p className="text-xl font-quicksand text-white/90 mb-10">
              Commandez dès maintenant et recevez votre portrait personnalisé en quelques jours
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-10 py-5 bg-white text-gray-900 font-quicksand font-bold text-lg rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-brush-line text-xl"></i>
              <span>Commander maintenant</span>
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}